import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
    Box,
    Collapse,
    IconButton,
    LinearProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
} from '@material-ui/core';

import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import {useHistory} from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CreateIcon from '@material-ui/icons/Create';
import ModalEditar from './NvoEditModelo'
import {ErrorGeneral, llamaApiCargaToken} from '../funciones/ClienteAxios';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: process.env.REACT_APP_COLOR
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
});

export default function TablaModelo({ listModeloFiltro, filtroSerie, filtroNoEco, filtroDescr, funcionActualizar,  }) {
    const classes = useStyles();
    let history = useHistory();
    const idusu = localStorage.getItem('UsuId');
    const source = axios.CancelToken.source();
    const [registro, setRegistro] = useState([]);
    const [open, setOpen] = useState(false);
    const [auxMarca, setAuxMarca] = useState(0);
    const [tipoModal, setTipoModal] = useState(0);
    const [ordenSelecc, setOrdenSelecc] = useState(0);
    const [seleccionadoEdit, setSeleccionadoEdit] = useState([]);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(true)    

    useEffect(() => {                          
        if (listModeloFiltro.length !== 0 ) {
            setAuxMarca(listModeloFiltro[0].Marca)
        }
        guardarDatos(listModeloFiltro)
        return () => {
            source.cancel();
        }
    }, [listModeloFiltro]);

    const seleccionado = (auxReg) => {
        setRegistro(auxReg)                
    }

    function editarReg(auxFalla) {
        setSeleccionadoEdit(auxFalla)  
        setTipoModal(2)      
        setModalAbierto(true)
    }

    function nvoAbrir() {
        setRegistro([])  
        setTipoModal(1)      
        setModalAbierto(true)
    }

    function verMas(auxId) {

        if (auxId === registro) {
            setOpen(!open)
        } else {
            setOpen(true)
        }
        setOrdenSelecc(auxId)
    }


    const minuscula=(cadena)=>{
        let nvo=""
        nvo = cadena.substring(0,1) + cadena.substring(1,cadena.length).toLowerCase()
        return nvo}

    function Row(props) {
        const {row} = props;

        return (
        <>
            <TableRow onClick={() => { seleccionado(row); }}
                className={classes.tableRow} selected={registro?.Id === row.Id}
                classes={{hover: classes.hover, selected: classes.selected}}
            >
         
              <TableCell align="center" padding={'none'} style={{width: 35 + 'px'}}>
                    <Tooltip title={'Editar'}>
                        <IconButton aria-label="add circle" size="small" onClick={() => editarReg(row)}
                            component="span">
                            {registro?.Id === row.Id ? <CreateIcon style={{color: 'white'}}/> :
                                <CreateIcon color="primary"/>}
                        </IconButton>
                    </Tooltip>
                </TableCell>                  
               <TableCell className={classes.tableCell} align="left" padding={'none'} style={{width: 75 + 'px'}}>
                    {moment.utc(row.Freg).local(true).format("DD/MM/YYYY HH:mm")}
                </TableCell>                                             
                <TableCell className={classes.tableCell} align="left" padding={'none'}
                    style={{  width: 100 + 'px', paddingLeft:".5rem"}}>
                    {minuscula( row.Descr)}
                </TableCell>
                <TableCell className={classes.tableCell} align="left" padding={'none'}
                    style={{  width: 100 + 'px', paddingLeft:".5rem"}}>
                    {minuscula( row.Alias)}
                </TableCell>
            </TableRow>         
        </>
        );
    }

    function tablaCompleta(auxlista) {
        return (
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>                                        
                    <TableCell align="center" padding='none'>
                           <Tooltip title="Nuevo Modelo">
                               <IconButton size={"small"} color="primary" onClick={() => nvoAbrir()}
                                    style={{}}>
                                    <AddCircleOutlineIcon/>
                                </IconButton>
                                </Tooltip>
                                {`${auxlista.length}  `}
                            </TableCell>                                           
                    <TableCell align="center" padding='none'>Fecha Registro</TableCell>                                        
                    <TableCell align="center" padding='none'>Nombre</TableCell>                 
                    <TableCell align="center" padding='none'>Alias</TableCell>                                        
                </TableRow>
            </TableHead>
            <TableBody>
                {auxlista.length !== 0 ? (auxlista.map((row) => {
                   if (row.Id!==0 && row.Id!=="0" ) {
                    return <Row key={row.Id} row={row}/>
                   } 
                })) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
        <TableContainer className={classes.container2}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">  </TableCell>
                        <TableCell align="left">Fecha</TableCell>
                        <TableCell align="left">Estatus</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow
                        className={classes.tableRow}
                    >
                        <TableCell className={classes.tableCell} align="center"></TableCell>
                        <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                        <TableCell className={classes.tableCell} align="left">Registros</TableCell>

                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
        )
    }

    const tablaSinResultados = () => {
        return (
        <TableContainer className={classes.container2}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">  </TableCell>
                    <TableCell align="left">Fecha</TableCell>
                    <TableCell align="left">Estatus</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow className={classes.tableRow} >
                    <TableCell className={classes.tableCell} align="center"> </TableCell>
                    <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                    <TableCell className={classes.tableCell} align="left">coincidencias</TableCell>
                </TableRow>
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    function filtro(campo,cadena) {
        let info = []
        if (cadena.length !== 0) {
            let auxCadena = cadena.trim();
            info = datos.filter((dat) => dat[campo].toString().search(auxCadena.toUpperCase()) !== -1)

        } 

        let metodos = null
        if (info.length > 0) {
            metodos = tablaCompleta(info)
        } else {
            metodos = tablaSinResultados()
        }
        return metodos;
    }

    const modEdit = modalAbierto ? <ModalEditar modalAbierto={modalAbierto} setModalAbierto={setModalAbierto} auxMarca={auxMarca} tipoModal={tipoModal}
                                        titulo={tipoModal === 1 ? `Nuevo Modelo`: `Editar Modelo`} regis={registro} funcionActuliza={funcionActualizar} /> :null
    const contenido4 = filtroDescr  !==""  ? filtro("Descr", filtroDescr) : tablaCompleta(datos)
    const contenido3 = filtroSerie  !==""  ? filtro("Serie", filtroSerie) : contenido4
    const contenido2 = filtroNoEco !=="" ? filtro("NoEco", filtroNoEco) : contenido3
    const contenido = datos.length !== 0 ? contenido2 : tablaSinDatos()
    const tabla =contenido// espera ? (<Box><LinearProgress/> </Box>) : (contenido)
 
    return (
    <Paper className={classes.root}>
        {tabla}
        {modEdit}
        
    </Paper>
    );
}